import { render, staticRenderFns } from "./UserProfileMenu.vue?vue&type=template&id=47a1682a"
import script from "./UserProfileMenu.vue?vue&type=script&lang=js"
export * from "./UserProfileMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports